export const PlanilhaDiariaConfig = themeContext => {
  return {
    maintainAspectRatio: true,
    padding: 0,
    cutoutPercentage: 70,
    legend: {
      display: true,
      position: 'right',
      align: 'center',
      fullWidth: true,
      reverse: false,
      labels: {
        fontColor: themeContext?.fontColor,
        padding: 15,
        fontSize: 14,
      },
    },

    animation: {
      duration: 3000,
      easing: 'easeOutQuart',
    },

    tooltips: {
      backgroundColor: themeContext?.tooltip.background,
      titleFontColor: themeContext?.tooltip.fontColor,
      bodyFontColor: themeContext?.tooltip.fontColor,
      bodySpacing: 4,
      xPadding: 12,
      mode: 'nearest',
      intersect: 0,
      position: 'nearest',
    },

    scales: {
      yAxes: [
        {
          display: 0,
          ticks: {
            display: false,
          },
          gridLines: {
            drawBorder: false,
            zeroLineColor: 'transparent',
            color: 'rgba(255,255,255,0.05)',
          },
        },
      ],

      xAxes: [
        {
          display: 0,
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: 'rgba(255,255,255,0.1)',
            zeroLineColor: 'transparent',
          },
          ticks: {
            display: false,
          },
        },
      ],
    },
  };
};

export const graphSemanalOptions = themeContext => {
  return {
    data: canvas => {
      const ctx = canvas.getContext('2d');
      var gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      // gradientStroke.addColorStop(1, 'rgba(253,93,147,0.8)')
      // gradientStroke.addColorStop(0, 'rgba(253,93,147,0)') // blue colors
      return {
        labels: ['1', '2', '3', '4', '5', '6', '7'],
        datasets: [
          {
            label: 'Data',
            fill: false,
            backgroundColor: gradientStroke,
            hoverBackgroundColor: gradientStroke,
            borderColor: '#ff5991',
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [80, 100, 70, 80, 120, 80, 10],
          },
          {
            label: 'Data',
            fill: false,
            backgroundColor: gradientStroke,
            hoverBackgroundColor: gradientStroke,
            borderColor: '#1D8CF8',
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [30, 40, 100, 200, 3, 2, 1],
          },
        ],
      };
    },
    options: {
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'top',
        fullWidth: true,
        reverse: false,
        labels: {
          fontColor: themeContext?.fontColor,
          fontSize: 12,
        },
      },

      animation: {
        duration: 3000,
        easing: 'easeOutQuart',
      },
      tooltips: {
        backgroundColor: '#f5f5f5',
        titleFontColor: '#333',
        bodyFontColor: '#666',
        bodySpacing: 4,
        xPadding: 12,
        mode: 'nearest',
        intersect: 0,
        position: 'nearest',
      },
      responsive: true,
      scales: {
        yAxes: [
          {
            gridLines: {
              drawBorder: false,
              color: themeContext?.graph.graphAxis,
              zeroLineColor: 'transparent',
            },
            ticks: {
              suggestedMin: 0,
              suggestedMax: 10,
              padding: 10,
              fontColor: themeContext?.fontColor,
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              drawBorder: false,
              color: themeContext?.graph.graphAxis,
              zeroLineColor: 'transparent',
            },
            ticks: {
              padding: 5,
              fontColor: themeContext?.fontColor,
              fontSize: 14,
            },
          },
        ],
      },
    },
  };
};
